import React from 'react'

import DataTypeIcon from 'components/common/DataTypeIcon'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

export const onDeleteDataset = (setAlert, resetAlert, deleteDataset) => {
  setAlert({
    header: 'Ta bort dataset',
    color: 'warning',
    content: (
      <>
        <Text paragraph>
          När du tar bort ett dataset försvinner det permanent och kan inte
          återställas.
        </Text>
        <Text paragraph>Vill du verkligen ta bort aktuellt dataset?</Text>
      </>
    ),
    onCancel: () => resetAlert(),
    onOk: () => {
      deleteDataset()
      resetAlert()
    },
    cancelText: 'Avbryt',
    okText: 'Ta bort'
  })
}

export const getDatasets = (tables) =>
  tables.map((table) => ({
    id: table.id,
    slug: table.included.endpoint.attributes.slug,
    name: table.attributes.plural,
    outputAttributes: table.attributes.output_attributes.map((item) => ({
      id: item.id,
      ...item.attributes
    })),
    updatedAt: table.attributes.updated_at
  }))

export const getHeaders = (dataset, transformation) => {
  if (dataset && transformation) {
    return transformation.output_attributes
      .map((ontologyAttribute, i) => ({
        ...ontologyAttribute,
        index:
          ontologyAttribute.index || ontologyAttribute.index === 0
            ? ontologyAttribute.index
            : i
      }))
      .sort((a, b) => (a.index < b.index ? -1 : 1))
      .map((ontologyAttribute) => {
        const attribute = dataset.outputAttributes.find(
          (oa) => oa.id === ontologyAttribute.output_attribute_id
        )

        return attribute
          ? {
              label: (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <DataTypeIcon type={attribute.type} />
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {
                      // newAttributes references their own dataset as origin.
                      ontologyAttribute.origin_table_id !== dataset.id && (
                        <small className={'secondary tiny'}>
                          {ontologyAttribute.origin_table_name}
                        </small>
                      )
                    }
                    <small>{attribute.name}</small>
                  </Box>
                </Box>
              ),
              key: attribute.name,
              render: function renderItem(value) {
                if (attribute.type === 'BOOLEAN') {
                  return value ? 'Sant' : 'Falskt'
                }

                return value
              }
            }
          : null
      })
      .filter(Boolean)
  }

  return []
}
